module.exports = __webpack_public_path__ + "img/unload-2-2.a84480c0.png";